import { API_URL } from '../config/api';

export const getJournalList = async () => {
    const response = await fetch(`${API_URL}/journal-list`, {
        credentials: 'include',
    });
    if (response.status === 404 || response.status === 403) return null;
    if (!response.ok) throw new Error('Nepodařilo se načíst seznam');
    return response.json();
};

export const createJournalList = async () => {
    const response = await fetch(`${API_URL}/journal-list`, {
        method: 'POST',
        credentials: 'include',
    });
    if (!response.ok) throw new Error('Nepodařilo se vytvořit seznam');
    return response.json();
};

export const addJournalToList = async (journalId) => {
    const response = await fetch(`${API_URL}/journal-list/journals/${journalId}`, {
        method: 'POST',
        credentials: 'include',
    });
    if (!response.ok) throw new Error('Nepodařilo se přidat knihu do seznamu');
    return response.json();
};

export const removeJournalFromList = async (journalId) => {
    const response = await fetch(`${API_URL}/journal-list/journals/${journalId}`, {
        method: 'DELETE',
        credentials: 'include',
    });
    if (!response.ok) throw new Error('Nepodařilo se odebrat knihu ze seznamu');
    return response.json();
};

export const deleteJournalList = async () => {
    const response = await fetch(`${API_URL}/journal-list`, {
        method: 'DELETE',
        credentials: 'include',
    });
    if (!response.ok) throw new Error('Nepodařilo se smazat seznam');
};
